import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMedicalFolder = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17 13.875C17 13.7092 16.9342 13.5503 16.8169 13.4331C16.6997 13.3158 16.5408 13.25 16.375 13.25H15.125V12C15.125 11.8342 15.0592 11.6753 14.9419 11.5581C14.8247 11.4408 14.6658 11.375 14.5 11.375H13.25C13.0842 11.375 12.9253 11.4408 12.8081 11.5581C12.6908 11.6753 12.625 11.8342 12.625 12V13.25H11.375C11.2092 13.25 11.0503 13.3158 10.9331 13.4331C10.8158 13.5503 10.75 13.7092 10.75 13.875V15.125C10.75 15.2908 10.8158 15.4497 10.9331 15.5669C11.0503 15.6842 11.2092 15.75 11.375 15.75H12.625V17C12.625 17.1658 12.6908 17.3247 12.8081 17.4419C12.9253 17.5592 13.0842 17.625 13.25 17.625H14.5C14.6658 17.625 14.8247 17.5592 14.9419 17.4419C15.0592 17.3247 15.125 17.1658 15.125 17V15.75H16.375C16.5408 15.75 16.6997 15.6842 16.8169 15.5669C16.9342 15.4497 17 15.2908 17 15.125V13.875Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 20.125H19.5C19.9973 20.125 20.4742 19.9275 20.8258 19.5758C21.1775 19.2242 21.375 18.7473 21.375 18.25V8.875H6.375V18.25C6.375 18.7473 6.17746 19.2242 5.82582 19.5758C5.47419 19.9275 4.99728 20.125 4.5 20.125C4.00272 20.125 3.52581 19.9275 3.17417 19.5758C2.82254 19.2242 2.625 18.7473 2.625 18.25V5.125C2.625 4.79348 2.7567 4.47554 2.99112 4.24112C3.22554 4.0067 3.54348 3.875 3.875 3.875H8.875C9.20652 3.875 9.52446 4.0067 9.75888 4.24112C9.9933 4.47554 10.125 4.79348 10.125 5.125V5.75C10.125 5.91576 10.1908 6.07473 10.3081 6.19194C10.4253 6.30915 10.5842 6.375 10.75 6.375H18.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMedicalFolder.displayName = 'SvgMedicalFolder';
export default SvgMedicalFolder;
